import { generateBindings, view } from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-button';
import { html } from 'lit';

export const [Button] = view('esui-mwc-button', {
  Props: class {
    label?: string = undefined;
    disabled = false;
    icon?: string = undefined;
    trailingIcon = false;
    raised = false;
    unelevated = false;
    outlined = false;
    dense = false;
  },
  mapBuilder: ButtonBuilder => (label: string) => ButtonBuilder().label(label),
  template(props) {
    const propsBindings = generateBindings(props);

    return html`
      <mwc-button type="button" ${spread({ ...propsBindings })}></mwc-button>
    `;
  },

  noShadow: true,
});
